import React from 'react';
import { Logo, Flag, Pill } from './ui';
import { seasonStatus } from '../../lib/leagueHelpers';

export default function LeagueHeader({ data }) {
  const d = data?.detail || {};
  const season = d?.currentseason || data?.currentSeason || data?.season;
  const st = seasonStatus(season);
  const teams = data?.teams || [];
  const rounds = data?.rounds || [];
  const totalRounds = rounds.length;
  const current = rounds.find((r) => r?.is_current);
  const done = (current ? Math.max(0, Number(current.name) - 1) : 0) || rounds.filter((r) => r?.finished).length;
  const left = totalRounds ? totalRounds - done : null;
  const sportType = [d?.type, d?.sub_type].filter(Boolean).join(' · ');

  return (
    <div className="i-card p-5 mb-4">
      <div className="flex flex-wrap items-center gap-4">
        <Logo src={d?.image_path} alt={d?.name} size={84} fallback={d?.name} />
        <div className="min-w-0 flex-1">
          <h1 className="i-fg text-2xl font-bold tracking-tight">{d?.name || '—'}</h1>
          <div className="flex flex-wrap items-center gap-3 mt-2">
            <Flag src={d?.country?.image_path} alt={d?.country?.name} size={18} />
            <span className="i-mute text-sm">{d?.country?.name || '—'}</span>
            {sportType && <Pill className="i-bd">{sportType}</Pill>}
            {d?.code && <Pill>{d.code}</Pill>}
            {d?.category && <Pill>{d.category}</Pill>}
            <Pill className={st.status === 'live' ? 'i-pos-def' : st.status === 'finished' ? 'i-bd' : ''}>{st.label}</Pill>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 pt-4 border-t border-shell-border">
        <div className="i-stat"><span className="i-mute text-xs">Season</span><span className="i-fg font-semibold">{season?.name || '—'}</span></div>
        <div className="i-stat"><span className="i-mute text-xs">Teams</span><span className="i-fg font-semibold">{teams.length || d?.team_count || '—'}</span></div>
        <div className="i-stat"><span className="i-mute text-xs">Rounds</span><span className="i-fg font-semibold">{totalRounds || '—'}</span></div>
        <div className="i-stat"><span className="i-mute text-xs">Played / Left</span><span className="i-fg font-semibold">{done || '—'} / {left ?? '—'}</span></div>
      </div>
    </div>
  );
}
